import React from 'react';
import { ContactSection, SectionHeaderBanner, SectionHeaderCopy } from '../../CommonComponents';  
import { IRPDFMainContent, contactsection } from '../InvestorRelations/CommonComps'
  
export default function BoardMeeting() {
    return (
      <>
        <SectionHeaderBanner banner="/images/investorrelations/pldt-corpwebsite-shareholdingstructure-banner.jpg">
          <SectionHeaderCopy
            category = "PRESS RELEASES AND DISCLOSURES"
            title = "BOARD MEETING/ STOCKHOLDERS' RELATED DISCLOSURES"
            headerClass="text-white"
            bodyClass="text-white"
          />
        </SectionHeaderBanner>
        <IRPDFMainContent apiendpoint="pressreleasesboardmeetingstockholders" />
        <ContactSection contents={contactsection}/>
      </>
    );
}

